
import { Component, Vue } from 'vue-property-decorator'
import { Article } from '@/common/storage'

@Component({
    name: 'rich-text'
})
export default class extends Vue {
    private richText = ''

    created() {
        const article = Article.get()
        if (article == null || article === '') {
            this.$router.replace('/')
        }
        this.richText = article!
    }

    beforeDestroy() {
        Article.remove()
    }
}
